import {
  EquipmentType_Read_Typeahead,
  getV1CompaniesCompanyIdEquipmentTypesTypeahead,
  GetV1CompaniesCompanyIdEquipmentTypesTypeaheadData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { EquipmentTypeTypeahead } from '~hooks/useEquipment/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  EquipmentType_Read_Typeahead,
  EquipmentTypeTypeahead,
  GetV1CompaniesCompanyIdEquipmentTypesTypeaheadData
> & { companyId: string };

export default function AutocompleteEquipmentTypesTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteEquipmentTypesTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdEquipmentTypesTypeahead,
      }}
      parseFn={(item: EquipmentType_Read_Typeahead) => {
        const parsed = EquipmentTypeTypeahead.parse(item);

        return { _entity: parsed, label: parsed.name, value: parsed.id };
      }}
    />
  );
}
